import instObj from '@/backend/axios-instances'

const resource = "/storages"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  },
  transfer(data, parameters) {
    return instance.post(`${resource}/transfers`, data, { params: parameters });
  }
}
